import { render, staticRenderFns } from "./StepInspection.vue?vue&type=template&id=1c404732&scoped=true&"
import script from "./StepInspection.vue?vue&type=script&lang=js&"
export * from "./StepInspection.vue?vue&type=script&lang=js&"
import style0 from "./StepInspection.vue?vue&type=style&index=0&id=1c404732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c404732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepperContent})
